<template>
  <div v-if="!isMobile" class="viewer-app-controls" data-testid="viewer-app-controls">
    <span class="viewer-app-controls__divider" aria-hidden="true" />
    <AdminMenu v-if="isSystemAdmin" compact />
    <Notifications />
    <UserMenu :is-expanded="false" :name="name || email" :avatar="avatarUrl" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import AdminMenu from '@/components/layout/header/AdminMenu.vue';
import Notifications from '@/components/layout/header/notifications/Notifications.vue';
import UserMenu from '@/components/sidebar/menu/User.vue';
import { useMobileDetection } from '@/composables/useMobileDetection';
import { useUserStore } from '@/store/useUserStore';

const { isMobile } = useMobileDetection();
const { avatarUrl, name, email, isSystemAdmin } = storeToRefs(useUserStore());
</script>

<style scoped>
.viewer-app-controls {
  @apply flex items-center gap-2 flex-none;
}

.viewer-app-controls__divider {
  @apply h-7 w-px mx-3 bg-slate-200 dark:bg-zinc-700;
}

.viewer-app-controls :deep([data-testid='header-notifications']) {
  @apply shrink-0;
}

.viewer-app-controls :deep(.sidebar-user-menu) {
  @apply w-auto shrink-0 max-w-none;
}
</style>
